
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reasons",
      function () {
        return require("private-next-pages/reasons/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reasons"])
      });
    }
  